import { CSSProperties, useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import { GoBackLinkComponent, leftHeaderContainerStyle, rightHeaderContainerStyle } from '@vivli/shared/components';
import { Size } from '@vivli/shared/theme';
import { AdminStudyDatasetTabsComponent } from './admin-study-dataset-tabs.component';
import { AdminStudyHeaderContainerComponent } from './admin-study-header-container.component';
import { DTICommonConst } from '@vivli/shared/infrastructure/constants';
import { IStudy } from '@vivli/features/studies/infrastructure/interface';

const bodyContainerStyle: CSSProperties = {
    display: 'flex',
    flexDirection: 'row',
    flexGrow: 2,
    height: 'calc(100% - 70px)',
    overflow: 'auto'
};

const studyButtonsContainerStyle: CSSProperties = {
    ...rightHeaderContainerStyle,
    alignItems: 'right',
    marginTop: Size.PADDING
};

const topHeaderContainerStyle: CSSProperties = {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    flexGrow: 2,
    marginLeft: '40px',
    paddingRight: '60px'
};

export const AdminStudyFormComponent = () => {
    const formApi = useFormContext<IStudy>();

    useEffect(() => {
        // force initial validation
        formApi.trigger();
    }, []);

    return (
        <>
            <div style={topHeaderContainerStyle}>
                <div style={leftHeaderContainerStyle}>
                    <GoBackLinkComponent dataId={DTICommonConst.HeaderApprovalButton('GoBack')} />
                </div>
                <div style={studyButtonsContainerStyle}>
                    <AdminStudyHeaderContainerComponent />
                </div>
            </div>
            <div style={bodyContainerStyle}>
                <AdminStudyDatasetTabsComponent />
            </div>
        </>
    );
};
